import React from "react"
import { Route, Routes, BrowserRouter } from "react-router-dom"

import WorkspaceLayout from "~/layouts/Workspace"
import Dashboard from "~/views/Dashboard"

import ClientList from "~/views/ClientList"
import BookingCalendar from "../views/Workspace/Bookings/BookingCalendar";
import BookingList from "~/views/BookingList"
import BookingCreated from "~/views/BookingCreated"
import NewBooking from "~/views/NewBooking"
import EditBooking from "~/views/EditBooking"
import AreaList from "~/views/AreaList"
import NewArea from "~/views/NewArea"
import EditArea from "~/views/EditArea"
import SalesReport from "~/views/SalesReport"
import ReportsView from "~/views/ReportsView"
import { AreaView, BookingView, ClientView, SponsorshipView } from "~/views"
import VenueSettings from "~/views/VenueSettings"
import PacksList from "~/views/PacksList"
import LineItemsList from "~/views/LineItemsList"
import NewPack from "~/views/NewPack"
import EditPack from "~/views/EditPack"
import PackView from "~/views/PackView"
import NewLineItem from "~/views/NewLineItem"
import EditLineItem from "~/views/EditLineItem"
import LineItemView from "~/views/LineItemView"
import CategoriesList from "~/views/CategoriesList"
import NewCategory from "~/views/NewCategory"
import EditCategory from "~/views/EditCategory"
import CategoryView from "~/views/CategoryView"
import MenusList from "~/views/MenusList"
import NewMenu from "~/views/NewMenu"
import EditMenu from "~/views/EditMenu"
import MenuView from "~/views/MenuView"
import SponsorshipsList from "~/views/SponsorshipsList"
import EditSponsorship from "~/views/Sponsorship/EditSponsorship"
import BookingAvailableDatesCalendar from "../views/Workspace/Bookings/BookingAvailableDatesCalendar.tsx";

import PaymentList from "~/views/Workspace/Payments/PaymentList"
import PaymentView from "~/views/Workspace/Payments/PaymentView"
import PayoutList from "~/views/Workspace/Payments/PayoutList"
import PayoutView from "~/views/Workspace/Payments/PayoutView"

// crm
import AccountList from "~/views/Workspace/Accounts/AccountList"
import AccountView from "~/views/Workspace/Accounts/AccountView"
import NewAccount from "~/views/Workspace/Accounts/NewAccount"
import EditAccount from "~/views/Workspace/Accounts/EditAccount"

import ContactList from "~/views/Workspace/Contacts/ContactList"
import ContactView from "~/views/Workspace/Contacts/ContactView"
import NewContact from "~/views/Workspace/Contacts/NewContact"
import EditContact from "~/views/Workspace/Contacts/EditContact"

import DealList from "../views/Workspace/Deals/DealList";
import DealView from "../views/Workspace/Deals/DealView";
import NewDeal from "../views/Workspace/Deals/NewDeal";
import EditDeal from "../views/Workspace/Deals/EditDeal";
import DealsPipelineList from "../views/Workspace/Deals/DealsPipelineList";
import ImportList from "~/views/Workspace/Imports/ImportList"
import ImportView from "~/views/Workspace/Imports/ImportView"

import TaskList from "../views/Workspace/Tasks/TaskList";

import DealsReportingDashboard from "../views/Workspace/DealsReporting/DealsReportingDashboard";

import getAppConfig from "~/utils/getAppConfig"

const { venueSlug } = getAppConfig()

const Router = () => {
  return (
    <BrowserRouter basename={`workspace/${encodeURIComponent(venueSlug)}`}>
      <Routes>
        <Route path="/" element={<WorkspaceLayout />}>
          <Route path="/" index element={<Dashboard />} />
          <Route path="/clients" element={<ClientList />} />
          <Route path="/clients/:id" element={<ClientView />} />
          <Route path="/bookings" element={<BookingList />} />
          <Route path="/calendar/bookings" element={<BookingCalendar />} />
          <Route path="/bookings/new" element={<NewBooking />} />
          <Route path="/bookings/created" element={<BookingCreated />} />
          <Route path="/bookings/:id" element={<BookingView />} />
          <Route path="/bookings/:id/edit" element={<EditBooking />} />
          <Route path="/calendar/available-dates" element={<BookingAvailableDatesCalendar />} />
          <Route path="/areas" element={<AreaList />} />
          <Route path="/areas/new" element={<NewArea />} />
          <Route path="/areas/:id" element={<AreaView />} />
          <Route path="/areas/:id/edit" element={<EditArea />} />
          <Route path="/payments" element={<PaymentList />} />
          <Route path="/payments/payouts" element={<PayoutList />} />
          <Route path="/payments/payouts/:id" element={<PayoutView />} />
          <Route path="/payments/:id" element={<PaymentView />} />
          <Route path="/insights/sales" element={<SalesReport />} />
          <Route path="/reports" element={<ReportsView />} />
          <Route path="/settings/venue" element={<VenueSettings />} />
          <Route path="/packs" element={<PacksList />} />
          <Route path="/packs/new" element={<NewPack />} />
          <Route path="/packs/:id" element={<PackView />} />
          <Route path="/packs/:id/edit" element={<EditPack />} />
          <Route path="/menus" element={<MenusList />} />
          <Route path="/menus/new" element={<NewMenu />} />
          <Route path="/menus/:id" element={<MenuView />} />
          <Route path="/menus/:id/edit" element={<EditMenu />} />
          <Route path="/categories" element={<CategoriesList />} />
          <Route path="/categories/new" element={<NewCategory />} />
          <Route path="/categories/:id" element={<CategoryView />} />
          <Route path="/categories/:id/edit" element={<EditCategory />} />
          <Route path="/line-items" element={<LineItemsList />} />
          <Route path="/line-items/new" element={<NewLineItem />} />
          <Route path="/line-items/:id" element={<LineItemView />} />
          <Route path="/line-items/:id/edit" element={<EditLineItem />} />
          <Route path="/sponsorship" element={<SponsorshipsList />} />
          <Route path="/sponsorship/:id" element={<SponsorshipView />} />
          <Route path="/sponsorship/:id/edit" element={<EditSponsorship />} />
          <Route path="/imports" element={<ImportList />} />
          <Route path="/imports/:id" element={<ImportView />} />
          {/*CRM*/}
          <Route path="/accounts/" element={<AccountList />} />
          <Route path="/accounts/:id" element={<AccountView />} />
          <Route path="/accounts/new" element={<NewAccount />} />
          <Route path="/accounts/:id/edit" element={<EditAccount />} />

          <Route path="/contacts/" element={<ContactList />} />
          <Route path="/contacts/:id" element={<ContactView />} />
          <Route path="/contacts/new" element={<NewContact />} />
          <Route path="/contacts/:id/edit" element={<EditContact />} />

          {/*<Route path="/deals/" element={<DealList />} />*/}
          <Route path="/deals/:id" element={<DealView />} />
          <Route path="/deals/new" element={<NewDeal />} />
          <Route path="/deals/:id/edit" element={<EditDeal/>} />
          <Route path="/deals" element={<DealsPipelineList/>} />
          <Route path="/tasks" element={<TaskList/>} />
          <Route path="/crm/dashboard" element={<DealsReportingDashboard/>} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export default Router
